// Helper functions for leads-related logic
import moment from 'moment';

export function getStatusColor(status) {
  const colors = {
    'Ongoing': 'primary',
    'ongoing': 'primary',
    'Signed': 'success', 
    'signed': 'success',
    'Scheduled': 'warning',
    'scheduled': 'warning',
    'Cold': 'default',
    'cold': 'default',
    'Rejected': 'error',
    'rejected': 'error'
  };
  return colors[status] || 'default';
}

export function formatGrowthPercent(percent) {
  if (!percent) return 'No data';
  return `${percent > 0 ? '+' : ''}${percent.toFixed(1)}%`;
}

export function isFollowupOverdue(daysUntil) {
  return daysUntil < 0;
}

// Determine if a lead is a "hot prospect" based on existing backend data
export function isHotProspect(lead) {
  if (!lead) {
    return false;
  }
  
  // High growth and significant listener base indicates hot prospect
  const hasHighGrowth = lead.monthlyGrowthPercent && lead.monthlyGrowthPercent >= 10; 
  const hasGoodListenerBase = lead.monthlyListeners && lead.monthlyListeners >= 10000; 
  
  // Ongoing status indicates active interest (check both cases)
  const isActivelyEngaged = lead.status === 'Ongoing' || lead.status === 'ongoing';
  
  const result = (hasHighGrowth && hasGoodListenerBase) || isActivelyEngaged;
  
  return result;
}

// Calculate days until follow-up based on nextIntervention date
export function getDaysUntilFollowup(lead) {
  if (!lead?.nextIntervention?.intervened) {
    return null;
  }
  
  const interventionDate = moment(lead.nextIntervention.intervened);
  const today = moment();
  
  const days = interventionDate.diff(today, 'days');
  
  return days;
}